<template>
    <div class="signup">
        <h2>Over uw bedrijf</h2>

        <div class="form">

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="land">Vestigingsland</label>
                        <select id="land" class="form-control" :disabled="kvkConfirmed === true"
                                name="SignupForm[organization_country]" tabindex="2"
                                aria-required="true"
                                v-model="land" :class="{invalid: $v.land.$invalid}" v-on:input="submit"
                                @change="$v.land.$touch()">
                            <option value="">Selecteer Land</option>
                            <option value="NL">Nederland</option>
                            <option value="BE">België</option>
                            <option value="AF">Afghanistan</option>
                            <option value="AL">Albanië</option>
                            <option value="DZ">Algerije</option>
                            <option value="AS">Amerikaans Samoa</option>
                            <option value="UM">Amerikaanse kleinere afgelegen eilanden</option>
                            <option value="VI">Amerikaanse Maagdeneilanden</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarctica</option>
                            <option value="AG">Antigua en Barbuda</option>
                            <option value="AR">Argentinië</option>
                            <option value="AM">Armenië</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australië</option>
                            <option value="AZ">Azerbeidzjan</option>
                            <option value="BS">Bahama’s</option>
                            <option value="BH">Bahrein</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">Bolivia</option>
                            <option value="BA">Bosnië en Herzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouveteiland</option>
                            <option value="BR">Brazilië</option>
                            <option value="IO">Britse Gebieden in de Indische Oceaan</option>
                            <option value="VG">Britse Maagdeneilanden</option>
                            <option value="BN">Brunei</option>
                            <option value="BG">Bulgarije</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambodja</option>
                            <option value="CA">Canada</option>
                            <option value="KY">Caymaneilanden</option>
                            <option value="CF">Centraal-Afrikaanse Republiek</option>
                            <option value="CL">Chili</option>
                            <option value="CN">China</option>
                            <option value="CX">Christmaseiland</option>
                            <option value="CC">Cocoseilanden</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comoren</option>
                            <option value="CG">Congo</option>
                            <option value="CD">Congo-Kinshasa</option>
                            <option value="CK">Cookeilanden</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">Curaçao</option>
                            <option value="CY">Cyprus</option>
                            <option value="DK">Denemarken</option>
                            <option value="DJ">Djibouti</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominicaanse Republiek</option>
                            <option value="DE">Duitsland</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egypte</option>
                            <option value="SV">El Salvador</option>
                            <option value="GQ">Equatoriaal-Guinea</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estland</option>
                            <option value="ET">Ethiopië</option>
                            <option value="FO">Faeröer</option>
                            <option value="FK">Falklandeilanden</option>
                            <option value="FJ">Fiji</option>
                            <option value="PH">Filipijnen</option>
                            <option value="FI">Finland</option>
                            <option value="FR">Frankrijk</option>
                            <option value="GF">Frans-Guyana</option>
                            <option value="PF">Frans-Polynesië</option>
                            <option value="TF">Franse Gebieden in de zuidelijke Indische Oceaan</option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgië</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GD">Grenada</option>
                            <option value="GR">Griekenland</option>
                            <option value="GL">Groenland</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinee</option>
                            <option value="GW">Guinee-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="HT">Haïti</option>
                            <option value="HM">Heard- en McDonaldeilanden</option>
                            <option value="HN">Honduras</option>
                            <option value="HU">Hongarije</option>
                            <option value="HK">Hongkong SAR van China</option>
                            <option value="IE">Ierland</option>
                            <option value="IS">IJsland</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesië</option>
                            <option value="IQ">Irak</option>
                            <option value="IR">Iran</option>
                            <option value="IL">Israël</option>
                            <option value="IT">Italië</option>
                            <option value="CI">Ivoorkust</option>
                            <option value="JM">Jamaica</option>
                            <option value="JP">Japan</option>
                            <option value="YE">Jemen</option>
                            <option value="JO">Jordanië</option>
                            <option value="CV">Kaapverdië</option>
                            <option value="CM">Kameroen</option>
                            <option value="KZ">Kazachstan</option>
                            <option value="KE">Kenia</option>
                            <option value="KG">Kirgizië</option>
                            <option value="KI">Kiribati</option>
                            <option value="KW">Koeweit</option>
                            <option value="HR">Kroatië</option>
                            <option value="LA">Laos</option>
                            <option value="LS">Lesotho</option>
                            <option value="LV">Letland</option>
                            <option value="LB">Libanon</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libië</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Litouwen</option>
                            <option value="LU">Luxemburg</option>
                            <option value="MO">Macao SAR van China</option>
                            <option value="MK">Macedonië</option>
                            <option value="MG">Madagaskar</option>
                            <option value="MW">Malawi</option>
                            <option value="MV">Maldiven</option>
                            <option value="MY">Maleisië</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MA">Marokko</option>
                            <option value="MH">Marshalleilanden</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauritanië</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Mexico</option>
                            <option value="FM">Micronesië</option>
                            <option value="MD">Moldavië</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolië</option>
                            <option value="MS">Montserrat</option>
                            <option value="MZ">Mozambique</option>
                            <option value="MM">Myanmar</option>
                            <option value="NA">Namibië</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NC">Nieuw-Caledonië</option>
                            <option value="NZ">Nieuw-Zeeland</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="KP">Noord-Korea</option>
                            <option value="MP">Noordelijke Marianeneilanden</option>
                            <option value="NO">Noorwegen</option>
                            <option value="NF">Norfolkeiland</option>
                            <option value="UG">Oeganda</option>
                            <option value="UA">Oekraïne</option>
                            <option value="UZ">Oezbekistan</option>
                            <option value="OM">Oman</option>
                            <option value="TL">Oost-Timor</option>
                            <option value="AT">Oostenrijk</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PS">Palestijns Gebied</option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papoea-Nieuw-Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PN">Pitcairn</option>
                            <option value="PL">Polen</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                            <option value="QA">Qatar</option>
                            <option value="RE">Réunion</option>
                            <option value="RO">Roemenië</option>
                            <option value="RU">Rusland</option>
                            <option value="RW">Rwanda</option>
                            <option value="KN">Saint Kitts en Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="PM">Saint Pierre en Miquelon</option>
                            <option value="VC">Saint Vincent en de Grenadines</option>
                            <option value="SB">Salomonseilanden</option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">Sao Tomé en Principe</option>
                            <option value="SA">Saoedi-Arabië</option>
                            <option value="SN">Senegal</option>
                            <option value="SC">Seychellen</option>
                            <option value="SL">Sierra Leone</option>
                            <option value="SG">Singapore</option>
                            <option value="SH">Sint-Helena</option>
                            <option value="SI">Slovenië</option>
                            <option value="SK">Slowakije</option>
                            <option value="SD">Soedan</option>
                            <option value="SO">Somalië</option>
                            <option value="ES">Spanje</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard en Jan Mayen</option>
                            <option value="SZ">Swaziland</option>
                            <option value="SY">Syrië</option>
                            <option value="TJ">Tadzjikistan</option>
                            <option value="TW">Taiwan</option>
                            <option value="TZ">Tanzania</option>
                            <option value="TH">Thailand</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad en Tobago</option>
                            <option value="TD">Tsjaad</option>
                            <option value="CZ">Tsjechië</option>
                            <option value="TN">Tunesië</option>
                            <option value="TR">Turkije</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks- en Caicoseilanden</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UY">Uruguay</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VA">Vaticaanstad</option>
                            <option value="VE">Venezuela</option>
                            <option value="GB">Verenigd Koninkrijk</option>
                            <option value="AE">Verenigde Arabische Emiraten</option>
                            <option value="US">Verenigde Staten</option>
                            <option value="VN">Vietnam</option>
                            <option value="WF">Wallis en Futuna</option>
                            <option value="EH">Westelijke Sahara</option>
                            <option value="BY">Wit-Rusland</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                            <option value="ZA">Zuid-Afrika</option>
                            <option value="GS">Zuid-Georgië en Zuidelijke Sandwicheilanden</option>
                            <option value="KR">Zuid-Korea</option>
                            <option value="SS">Zuid-Soedan</option>
                            <option value="SE">Zweden</option>
                            <option value="CH">Zwitserland</option>
                        </select>
                        <div v-if="$v.land.$error">
                            <p class="help has-text-light" v-if="!$v.land.required">
                                Veld is vereist</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-lg-6">
                    <div class="form-group">
                        <label for="kvk">KvK-nummer</label>
                        <input type="text" id="kvk" class="form-control" name="input[kvk]" tabindex="4"
                               placeholder="bv 12345678" v-model="kvk" :class="{invalid: $v.kvk.$invalid}"
                               :disabled="kvkConfirmed === true"
                               @change="$v.kvk.$touch()" v-on:input="checkKvk">
                        <div v-if="$v.kvk.$error">
                            <p class="help has-text-light" v-if="!$v.kvk.required">
                                Veld is vereist</p>
                        </div>
                        <div v-if="$v.kvk.$error">
                            <p class="help has-text-light" v-if="!$v.kvk.numeric">
                                Veld moet een geldig KvK nummer zijn</p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-lg-6">

                    <div class="form-group">
                        <label for="rechtsvorm">Rechtsvorm</label>
                        <select class="form-control" id="rechtsvorm" tabindex="3" v-model="rechtsvorm"
                                :class="{invalid: $v.rechtsvorm.$invalid}"
                                @change="$v.rechtsvorm.$touch()" v-on:input="submit" v-on:blur="checkKvk">
                            <option value="">Selecteer rechtsvorm</option>
                            <option value="1">B.V.</option>
                            <option value="12">BVBA</option>
                            <option value="2">C.V.</option>
                            <option value="11">Coöperatie U.A.</option>
                            <option value="3">Eenmanszaak</option>
                            <option value="10">GmbH</option>
                            <option value="15">Kerkgenootschap</option>
                            <option value="4">LTD.</option>
                            <option value="5">Maatschap</option>
                            <option value="6">N.V.</option>
                            <option value="13">Natuurlijk Persoon</option>
                            <option value="99">Overige</option>
                            <option value="14">Publiekrechtelijk Rechtspersoon</option>
                            <option value="7">Stichting</option>
                            <option value="9">V.O.F</option>
                            <option value="8">Vereniging</option>
                        </select>
                        <div v-if="$v.rechtsvorm.$error">
                            <p class="help has-text-light" v-if="!$v.rechtsvorm.required">
                                Veld is vereist</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="naam">Bedrijfsnaam</label>
                        <input type="text" id="naam" class="form-control" name="input[naam]" tabindex="1"
                               placeholder="Naam organisatie" v-model="naam" :class="{invalid: $v.naam.$invalid}"
                               @change="$v.naam.$touch()">
                        <div v-if="$v.naam.$error">
                            <p class="help has-text-light" v-if="!$v.naam.required">
                                Veld is vereist</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <span class="btn btn-primary" v-if="kvkChecked && !bLoading" @click="submit">Verder</span>
                        <div class="loader" id="loader-1" v-if="bLoading"></div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="kvkChecked && !kvkConfirmed">
            <div class="modal fade show d-block" v-if="kvkChecked && !kvkConfirmed" tabindex="-1" role="dialog">
                <div class="modal-dialog  modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Zijn onderstaande gegevens correct?</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                    @click="kvkChecked = false; kvkConfirmed = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <KvkSummary :kvkData="kvkData"></KvkSummary>
                            <div class="clearfix"></div>
                            <span class="btn btn-success" @click="kvkConfirmed = true">
                            <i class="fa fa-thumbs-up"></i> Dit is correct
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop fade show"></div>
        </template>


        <div class="kvk-summary" v-if="kvkConfirmed">
            <KvkSummary :kvkData="kvkData"></KvkSummary>
        </div>

    </div>
</template>

<script>
  import { validation } from '../mixins/organization-validations'
  import KvkSummary from './KvkSummary.vue'

  export default {
    name: 'Organization',
    mixins: [validation],
    components: {
      KvkSummary
    },
    data () {
      return {
        naam: '',
        land: 'NL',
        rechtsvorm: '',
        kvk: '',
        adres: '',
        postcode: '',
        stad: '',
        bLoading: false,
        kvkChecked: false,
        kvkConfirmed: false,
        kvkData: null
      }
    },
    methods: {
      requestFailed (e) {
        this.bLoading = false
        alert('an error occured while processing the request: ' + e)
      },
      checkKvk () {
        if (this.land === 'NL' && this.kvk.length === 8 && !this.kvkConfirmed) {
          this.bLoading = true
          this.kvkConfirmed = false
          this.kvkChecked = false
          this.$http.post('/signup/wizard/check-kvk', {
            'KvkForm':
              {
                organization_kvk: this.kvk,
              },
            'access_token': this.$store.state.accessToken
          })
            .then(request => this.parseCheckKvkResponse(request))
            .catch(() => this.requestFailed())
        }
      },
      submit () {
        const isValid = this.validate()
        if (isValid && this.kvkChecked && this.kvkConfirmed) {
          this.bLoading = true
          this.$http.post('/signup/wizard/organization', {
            'SignupForm':
              {
                organization_name: this.naam,
                organization_country: this.land,
                organization_legal_form: this.rechtsvorm,
                organization_kvk: this.kvk,
              },
            'access_token': this.$store.state.accessToken
          })
            .then(request => this.parseOrganizationResponse(request))
            .catch(() => this.requestFailed())
        }
      },
      parseOrganizationResponse (req) {
        if (req.status !== 200) {
          this.requestFailed(req)
          return false
        }
        if (req.data) {
          this.bLoading = true
          this.$store.commit('setOrganizationId', req.data.organization)
          this.$store.commit('setAccessToken', req.data.token)
          this.$emit('organizationCreated')
        }
        // const data = req.data;
      },
      parseCheckKvkResponse (req) {
        if (req.status !== 200) {
          this.requestFailed(req)
          return false
        }
        if (req.data) {
          this.bLoading = false
          this.kvkChecked = true
          this.$store.commit('setAccessToken', req.data.token)
          this.kvkData = req.data.result
          if (this.naam.length === 0) {
            this.naam = this.kvkData.mainItem.tradeNames.businessName ? this.kvkData.mainItem.tradeNames.businessName : this.kvkData.mainItem.tradeNames.shortBusinessName
          }
        }
        // const data = req.data;
      },
      validate () {
        this.$v.$touch()
        let isValid = true

        this.fields.forEach((field) => {
          if (this.$v[field].$invalid) {
            isValid = false
          }
        })

        return isValid
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .signup {
        margin: auto auto;
        max-width: 480px;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .kvk-summary {
        transform: scale(0.8);
        background-color: #fff;
        border: 1px solid #ccc;
        padding: 8px;
        /*margin: 1rem;*/
        text-align: left;
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);

        td {
            text-align: left;
        }
    }
</style>
